import { PlanPickerBody, PlanPickerResponse } from '../../../../API';
import { DataManagerState, DataManagerStateFullReturnType } from '../../../DataManager';

export type PlanPickerStateReturnType = DataManagerStateFullReturnType<PlanPickerResponse, PlanPickerBody>;

export const PlanPickerState = (name: string): PlanPickerStateReturnType =>
  DataManagerState<PlanPickerResponse, PlanPickerBody>(name);
